export const BYNDER_ACCOUNT_URL = 'media.vilebrequin.com'
export const BYNDER_SCRIPT_ID = 'bynder-widgets-js'
export const BYNDER_SCRIPT_SRC =
    'https://d8ejoa1fys2rk.cloudfront.net/bynder-embed/latest/bynder-embed.js'
